<template>
  <div class="workspace">
    <div class="section-heading">
      <h2>Make a payment</h2>
    </div>
    <thank-you v-if="sale_id" :mail="user.email.split('@')[1]" :sale_id="sale_id" />
    <div class="cart-form-row" v-if="!sale_id">
      <div class="cart-start-cont">
        <div class="cart-form-row cart-flex-row cart-start">
          <div class="cart-flex-item-full">Your trial period has expired. Please enter your credit card information to continue and initiate your subscription</div>
        </div>
      </div>

      <div class="cart-form-input stripe-card">
        <stripe-vue-card ref="paymentBridge" :seti="seti" :pi_secret="pi_secret" :info="{payAmount: 19900}"
                         v-if="pi_secret"/>
      </div>

      <div class="cart-total-cont">
        <div class="cart-form-row cart-flex-row cart-total">
          <div class="cart-flex-item">TOTAL:</div>
          <div class="cart-flex-item">${{ total_price }}/{{ product_freq }}</div>
        </div>
      </div>

      <div class="complete-payment" @click="submitPayment">Submit Payment</div>


      <div class="stripe-badge"><img alt="Guaranteed safe & secure checkout with Stripe"
                                     src="../../../assets/images/stripe-badge-white.png"/></div>
    </div>
  </div>
</template>
<script>
import StripeVueCard from '../../../components/stripe/StripeVueCard'
import ThankYou from '../../../views/pages/Checkout/components/ThankYou'

export default {
  data () {
    return {
      pi_secret: null,
      seti: null,
      subscription_id: null,
      stripe_customer: null,
      product: null,
      payment_success: false,
      sale_id: null
    }
  },
  metaInfo () {
    return {
      title: 'Payment',
      titleTemplate: '%s - AuthorizeLocal',
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: 'Payment Authorize Local Portal'
        },
        {
          vmid: 'keywords',
          name: 'keywords',
          content: 'Local SEO Solutions'
        }
      ]
    }
  },
  components: {
    StripeVueCard,
    ThankYou
  },
  mounted () {
    this.getBundle()
  },
  watch: {
  },
  computed: {
    total_price () {
      if (this.product) {
        return this.product.price.toFixed(2) // + (this.product.price * 0.0875)).toFixed(2)
      }
    },
    product_freq () {
      if (this.product) {
        return this.product.freq.charAt(0).toUpperCase() + this.product.freq.slice(1)
      }
      /*if (this.product.freq.includes('ily')) {
        const result = this.product.freq.replace('ily', 'y')
        return `${result.substring(0, 1).toUpperCase()}${result.substring(1)}`
      } else if (this.product.freq.includes('ly')) {
        const result = this.product.freq.replace('ly', '')
        return `${result.substring(0, 1).toUpperCase()}${result.substring(1)}`
      } else {
        return this.product.freq
      }*/
    },
    user () {
      return this.$store.state.AppActiveUser
    }
  },
  methods: {
    getBundle () {
      this.$store.dispatch('getBundleSlug', 'digital-scratch-off-campaigner-4')
        .then(response => {
          console.log('bundleslug', response)
          this.product = this.setPrices(response.data.data)
          console.log('product', this.product)
          this.getPaymentIntent(this.user)
        })
        .catch(e => {
          console.log(e)
        })
    },
    setPrices (product) {
      try {
        product.price = product.price / 100
        product.serviceList.map(service => {
          service.price = service.price / 100
        })
        return product
      } catch (e) {
        console.log('set price error', e)
      }
    },
    getPaymentIntent (user) {
      console.log('intentProduct', this.product)
      const payload = {
        bundle_id: this.product._id,
        user
      }
      this.$store.dispatch('newSaleMakePayment', payload)
        .then((response) => {
          console.log('pi', response)
          this.pi_secret = response.data.clientSecret
          this.seti = response.data.seti
          this.subscription_id = response.data.subscriptionId
          this.stripe_customer = response.data.stripe_customer
        })
        .catch((e) => {
          console.log(e)
          this.$vs.loading.close()
        })
    },

    saveSale (customer, bundle) {
      const sale = {
        price: parseFloat(this.total_price),
        customer,
        bundle,
        subscription_id: this.subscription_id
      }

      this.$store.dispatch('saveSale', sale)
        .then(response => {
          console.log('saveSale', response)
          this.$vs.loading.close()
          this.sale_id = response.data.data.sale_id
        })
        .catch(e => {
          console.log(e)
        })
    },
    submitPayment () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$vs.loading()
          this.$refs.paymentBridge.setup((response) => {
            console.log('stripe token and amount', response)
            if (response.error) {
              this.$vs.loading.close()
              console.log('failed payment')
            } else {
              const stripe_result = response.setupIntent
              if (stripe_result.status === 'succeeded') {
                this.payment_success = true
                this.saveSale(this.user._id, this.product._id)
                this.$vs.loading.close()
              } else {
                this.$vs.notify({
                  title: 'Failed',
                  text: 'Payment Failed',
                  color: 'warning',
                  iconPack: 'feather',
                  icon: 'icon-alert'
                })

                this.$vs.loading.close()
                console.log('failed payment')
              }
            }
          })
        }
      })
    }
  }
}
</script>
<style lang="scss">
.al-dash-module {
  display:none;
  min-width:500px;
  min-height:250px;
  border-radius: 7px;
  box-shadow:0px 0px 10px 1px rgba(0,0,0,.1);
  padding:10px;
}
.mod-head {
  margin-bottom:20px;
}
.task-row{
  &:hover{
    background-color:#f2f2f2;
    transform:translateY(-2px);
    border:1px solid orange;
  }
  &:last-child{
    margin-bottom:0;
  }
  display:flex;
  align-items:center;
  flex-wrap:wrap;
  justify-content: space-between;
  margin-bottom:10px;
  width:100%;
  background-color:#f6f6f6;
  cursor:pointer;
  transition:all .2s ease;
  border:1px solid #fff;
}
.task-col {
  &.task-title {
    width:60%;
    text-align: right;
  }
  &.task-icon{
    width:10%;
  }
  &.task-date{
    width:30%;
    font-size:12px;
    font-weight: 900;
    text-align: left;
  }
  i {
    font-size:20px;
    color:#003451;
  }
  padding:10px;
}
.task-title, .task-date{
  &:hover{
    color:#005488;
  }
}
.complete-payment{
  background-color:#32364e;
  color:#fff;
  font-weight: 700;
  text-align: center;
  padding:10px 20px;
  border-radius: 7px;
  align-self: flex-start;
  cursor:pointer;
  transition:all .2s ease;
  margin-top:40px;
  line-height: 2;
}
.complete-payment:hover{
  background-color:#1d2346;
}
.complete-payment{
  width: 50%;
  display:block;
  margin:40px auto 0 auto;
}
.stripe-badge{
  img{
    display:block;
    margin:40px auto 0 auto;
  }
}
.stripe-card{
    display:block;
    margin:40px auto 0 auto;
    width: 50%;
}
.stripe-information{
    display:block;
    margin:40px auto 0 auto;
    width: 50%;
}
.cart-loading {
  .loading {
    top: 40%;
  }
}
.checkout-steps{
  display:flex;
  justify-content: center;
  margin:40px 0;
  .chk-step{
    cursor: pointer;
    display:flex;
    justify-content: flex-start;
    align-items: center;
    position:relative;
    margin-right:2px;
    .chk-step-number{
      background-color:#fff;
      color:#ccc;
      border:1px solid #ccc;
      border-radius: 100%;
      min-width:25px;
      min-height: 25px;
      text-align: center;
      margin-right:5px;
    }
    .chk-step-name{
      font-weight:600;
      color:#ccc;
      font-size:14px;
    }
    .chk-step-bar{
      min-width:35px;
      height: 2px;
      background-color:#ccc;
      margin-left:2px;
    }
  }
  .completed{
    .chk-step-number{
      background-color:#005488;
      color:#fff;
      border-color: #005488;
    }
    .chk-step-name{
      color:#005488;
    }
    .chk-step-bar{
      background-color:#005488;
    }
  }
}
.sub{
  .cart-flex-item{
    font-weight:500;
    color:#3c3c3c;
  }
  .discount{
    color:green
  }
}
.cart-body{
  padding:50px;
  display:flex;
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - 216px);
}
.cart-cont{
  width:650px;
  min-height: max-content;
  border-radius: 7px;
  box-shadow: 0px 0px 5px 5px rgba(0,0,0,.1);
  padding:20px;
  display:flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.cart-col {
  min-height: 50vh;
  width:100%;
  padding:20px;
}
.cart-logo{
  text-align: center;
}
.cart-logo img {
  display:block;
  margin:0 auto;
  width:300px;
}
.cart-form{
  margin:20px 0;
}
.cart-form-row {
  width:100%;
}
.cart-form-label{
  font-size:20px;
  font-weight: 600;
  color:#005488;
  margin-bottom:15px;
}
.cart-input{
  width:100%;
  border:1px solid #ccc;
  border-radius: 7px;
  padding:10px;
  background-color:#f9f9f9f9;
}
.cart-input:focus{
  outline-color:#f08028;
}
.cart-form-input {
  margin-bottom:10px;
}
.cart-flex-row{
  display:flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}
.cart-flex-item{
  width:32%;

}
.cart-flex-item-full{
  width:100%;

}
.cart-sum .cart-flex-item.cart-item-icon {
  width:10%;
  font-size:14px;
  color:#8bc451;
  text-align: center;
}
.cart-sum .cart-flex-item.cart-item-name {
  width:90%;
}
.cart-sum .cart-flex-item.cart-item-price {
  width:15%;
  font-size:25px;
  font-weight: 900;
}
.cart-sum .cart-flex-item.cart-item-options {
  width:15%;
  font-size:12px;
  cursor:pointer;
}
.cart-sum .cart-form-row {
  padding:5px 0;
  border-bottom:1px solid #ccc;
}
.cart-sum .cart-item-name h3{
  color:#000;
  font-weight:500;
  font-size:16px;
}
.cart-sum .cart-item-name p{
  display:none;
}
.cart-item-options:hover{
  color:#f08028
}
.cart-sum .cart-form-label{
  font-weight: 700;
  font-size:22px;
}
.cart-total-cont{
  width:50%;
  display:block;
  margin:40px auto 0 auto;
}
.cart-total-cont .cart-form-row {
  border-bottom:none;
  font-weight: 900;
  margin-bottom:0;
}
.cart-total-cont .cart-flex-item:last-child{
  text-align: right;
}
.cart-total {
  border-top:1px solid #ccc;
  padding-top:20px;
  font-size:18px;
}

.cart-start-cont{
  width:50%;
  display:block;
  margin:40px auto 0 auto;
}
.cart-start-cont .cart-form-row {
  border-top:none;
  font-weight: 900;
  margin-top:0;
}
.cart-start-cont .cart-flex-item:last-child{
  text-align: right;
}
.cart-start {
  border-bottom:1px solid #ccc;
  padding-bottom:20px;
  font-size:18px;
}

.continue-button{
  margin-top:40px;
}
@media (max-width:768px){
  .checkout-steps{
    .chk-step{
      .chk-step-number{
        width:20px;
        height: 20px;
        min-width:20px;
        min-height: 20px;
        margin-right:2px;
        font-size:12px;
      }
      .chk-step-name{
        font-size:12px;
      }
      .chk-step-bar{
        width:15px;
        height: 2px;
      }
    }
  }
  .cart-body{
    padding:10px;
    align-items: flex-start;
  }
  .cart-cont{
    width:90%;
    height: max-content;
    padding:10px;

  }
  .cart-col {
    min-height: 100%;
    width:100%;
    padding:10px;
  }
  .cart-message {
    margin:20px 0 20px 0;
    font-size:12px;
  }
  .cart-form-label{
    font-size:16px;
  }
  .cart-sum .cart-flex-item.cart-item-icon {
    font-size:22px;
    text-align: center;
  }
  .cart-sum .cart-flex-item.cart-item-name {
    padding-left:10px;
  }
  .cart-sum .cart-flex-item.cart-item-price {
    font-size:18px;
    font-weight: 900;
  }
  .cart-sum .cart-flex-item.cart-item-options {
    font-size:14px;
    text-align:center;
  }
  .cart-sum .cart-flex-item.cart-item-options span {
    display:none;
  }
  .cart-sum .cart-item-name h3{
    font-size:14px;
  }
  .cart-sum .cart-item-name p{
    display:none;
  }
  .cart-sum .cart-form-label{
    font-weight: 900;
    font-size:16px;
  }
  .cart-total-cont{
    width:100%;
    margin-top:30px;
  }
  .cart-start-cont{
    width:100%;
    margin-top:30px;
  }

}
@media (max-width:520px){
  .checkout-steps {
    transform:scale(0.9);
  }
}
@media (max-width:470px){
  .checkout-steps {
    transform:scale(0.8);
  }
}
@media (max-width:432px){
  .checkout-steps {
    transform:scale(0.75);
  }
}
@media (max-width:400px){
  .checkout-steps {
    transform:scale(0.7);
  }
}
@media (max-width:378px){
  .checkout-steps {
    transform:scale(0.7);
  }
  .cart-cont{
    box-shadow:none;
  }
}
@media (max-width:340px){
  .cart-body{padding:0;}
  .cart-cont{
    width:100%;
    padding:10px;
  }
  .cart-flex-row{
    justify-content: flex-start;
  }
  .cart-message{
    font-size:16px;
  }
  .cart-sum .cart-flex-item.cart-item-price{
    width:30%;
    font-weight:700;
    font-size:16px;
    text-align:right;
  }
  .cart-total {
    justify-content: space-between;
    .cart-flex-item{
      width:max-content;
    }
  }
  .cart-start {
    justify-content: space-between;
    .cart-flex-item{
      width:max-content;
    }
  }
  .checkout-steps {
    transform:scale(1);
    justify-content: space-between;
    .chk-step{
      flex-wrap: wrap;
      text-align: center;
      justify-content: center;
      align-items: flex-start;
      width:23%;
    }
    .chk-step-bar{
      display:none;
    }
  }
}
</style>
